/** Values must match DB CHECK in scripts/add-company-capital-seniority.sql and interestedwith (add-interestedwith-capital-seniority.sql). */
export const PROFILE_COMPANY_CAPITAL_OPTIONS = [
  { value: '1_5m_usd', labelKey: 'dashboard.profileFields.capital1_5m' },
  { value: '5_10m_usd', labelKey: 'dashboard.profileFields.capital5_10m' },
  { value: 'above_10m_usd', labelKey: 'dashboard.profileFields.capitalAbove10m' },
];

export const PROFILE_SENIORITY_OPTIONS = [
  { value: 'c_suite', labelKey: 'dashboard.profileFields.seniorityCSuite' },
  { value: 'executive_leadership', labelKey: 'dashboard.profileFields.seniorityExecutive' },
  { value: 'government_leadership', labelKey: 'dashboard.profileFields.seniorityGovernment' },
];
